module.exports = __webpack_public_path__ + "static/media/aion.faa5cab4.svg";